<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Reporte de Nota de Crédito
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes y Consulta</span>
      <span> /</span>
      <span class="grey-text">Ventas</span>
      <span> /</span>
      <span>Reporte de Nota de Crédito</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- CABECERA -->
<form autocomplete="off" [formGroup]="formHeader">


  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">

      <div class="row filtros-body">
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" formControlName="fechaDesde"
              required>
            </mdb-date-picker>
            <div>
              <!-- <mdb-error *ngIf="formData.get('fechaDesde').hasError('required')">
              Ingrese fecha desde
            </mdb-error> -->
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechahasta" [inline]="true" [placeholder]="'Hasta'"
              formControlName="fechaHasta" required>
            </mdb-date-picker>
            <div>
              <!-- <mdb-error *ngIf="formData.get('fechaHasta').hasError('required')">
              Ingrese fecha hasta
            </mdb-error> -->
            </div>
          </div>
        </div>


        <div class="col" style="display: flex; align-items: center; max-width: 330px;">
          <strong>Buscar por: </strong>
          <!-- Material inline 1 -->
          <div class="form-check form-check-inline">
            <input type="radio" class="form-check-input" id="vendedor" formControlName="tipoVista"
              (change)='limpiarBuscarVendedor()' [value]="RB_TIPO_VENDEDOR" mdbInput />
            <label class="form-check-label" for="vendedor">Vendedor</label>
          </div>

          <!-- Material inline 2 -->
          <div class="form-check form-check-inline">
            <input type="radio" class="form-check-input" id="cliente" formControlName="tipoVista"
              (change)='limpiarBuscarPorCliente()' [value]="RB_TIPO_CLIENTE" mdbInput />
            <label class="form-check-label" for="cliente">Cliente</label>
          </div>
          <div
            *ngIf="formHeader.get('tipoVista').invalid && (formHeader.get('tipoVista').dirty || formHeader.get('tipoVista').touched)">
            <mdb-error *ngIf="formHeader.get('tipoVista').hasError('required')">
              Seleccione Vendedor o Cliente
            </mdb-error>
          </div>

        </div>

        <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
          (click)="abrirModalSeleccion()">
          <mdb-icon fas icon="search"></mdb-icon>
        </button>

        <ng-container *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VENDEDOR">
          <h6 class="text-info" *ngIf="VendedorSeleccionado" style="display: contents;">
            {{ VendedorSeleccionado.nombre }}
          </h6>
        </ng-container>
        <ng-container *ngIf="formHeader.get('tipoVista').value === RB_TIPO_CLIENTE">
          <h6 class="text-info" *ngIf="clientesSeleccionados" style="display: contents;">
            {{ clientesSeleccionados.razon_social }}
          </h6>
        </ng-container>

        <div class="col" style="max-width: 250px">
          <div class="md-form">
            <mdb-select label="Tipo de nota de crédito" [options]="optionsTipoNota"
              placeholder="Seleccionar tipo de documento" [filterEnabled]="true" formControlName="Tiponc"></mdb-select>
          </div>
        </div>
        <div class="col" style="max-width: 250px">
          <div class="md-form">
            <mdb-select label="Motivo de devolución" [options]="optionsMotivoDev" formControlName="motivodev"
              placeholder="Seleccionar motivo de devolución" [filterEnabled]="true"></mdb-select>
          </div>
        </div>
        <div class="col" style="max-width: 250px">
          <div class="md-form">
            <mdb-select label="Unidad de negocio" [highlightFirst]="false" [options]="optionsUnidNegocio"
              formControlName="unidadneg" placeholder="Seleccionar unidad de negocio"
              [filterEnabled]="true"></mdb-select>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer  justify-content-end" style="border-top: 1px solid #dee2e6">
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="limpiarfiltros()">
        <mdb-icon fas icon="broom"></mdb-icon>
        Limpiar
      </button>
      <button mdbBtn type="submit" class="btn btn-sm" color="secondary" size="sm" (click)="buscar(1)" mdbWavesEffect>
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
  <!-- FIN de CABECERA -->
</form>


<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="table-responsive mb-2">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientosAll">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Tipo NC</th>
            <th scope="col">Documento</th>
            <th scope="col">Fecha</th>
            <th scope="col">Doc. Afecto</th>
            <th scope="col">Rut</th>
            <th scope="col">Cliente</th>
            <th scope="col">Sucursal</th>
            <th scope="col">Monto</th>
            <th scope="col">Motivo</th>
            <th scope="col">Vendedor</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center" *ngIf="loading">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
            <td colspan="100%" style="text-align: center" *ngIf="!loading && listaMovimientos?.length === 0">No se
              encontró información</td>
          </tr>
          <tr *ngFor="let mov of listaMovimientos">
            <td>{{mov.tipo_ncnd_nombre}}</td>
            <td>{{mov.folio}}</td>
            <td>{{mov.fecha_emision | fecha}}</td>
            <td>{{mov.doc_ref}}</td>
            <td>{{mov.rutFormato | rut}}</td>
            <td>{{mov.cliente_nombre}}</td>
            <td>{{mov.sucursal_nombre}}</td>
            <td>{{mov.monto | numerico}}</td>
            <td>{{mov.motivo_dev_nombre}}</td>
            <td>{{mov.vendedor_nombre}}</td>
          </tr>

        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaMovimientosAll?.length > 0"></app-pagination>

      </table>




    </div>

    <div class="row" *ngIf="listaMovimientosAll">
      <div class="col" style="max-width: 500px;">
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col"></th>
              <th scope="col">NC</th>
              <th scope="col">Montos</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="font-weight: bold; color: red;">Totales</td>
              <td>{{TotalNC}}</td>
              <td>{{Totalmonto | numerico}}</td>
            </tr>

          </tbody>

        </table>
      </div>
    </div>
  </div>
</div>

<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1">
    <div class="row">
      <div class="col justify-content-end" style="max-width: 100%;">
        <button size="sm" class="btn btn-sm" mdbBtn type="button" color="success" (click)="downloadExcelPdf('XLS')"
          mdbWavesEffect>
          Excel
        </button>
      </div>
    </div>
  </div>
</div>


<!-- MODAL seleccionarVendedor -->
<app-modal-seleccionar-vendedor [multiple]="false" queryType="ONLY_RUT"
  (onSelectSingle)="onVendedorSeleccionado($event)" (onNotFound)="onVendedorNoEncontrado()">
</app-modal-seleccionar-vendedor>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" queryType="ONLY_RUT" (onSelectSingle)="onClienteSeleccionado($event)"
  showInfoClienteInactivoBloqueado="true" [busquedaxEstado]="3" (onNotFound)="onClienteNoEncontrado()">
</app-modal-seleccionar-cliente>